export var Actions;
(function (Actions) {
    Actions["GET_NOTIFICATION"] = "getNotificationAction";
    Actions["READ_NOTIFICATION"] = "readNotificationAction";
})(Actions || (Actions = {}));
export var Mutations;
(function (Mutations) {
    Mutations["SET_NOTIFICATION"] = "setNotificationMutation";
    Mutations["SET_NOTIFICATION_SUMMARY"] = "setNotificationSummaryMutation";
    Mutations["SET_NOTIFICATION_LOADING"] = "setNotificationLoadingMutation";
    Mutations["SET_NOTIFICATION_PAGINATION"] = "setNotificationPaginationMutation";
    Mutations["SET_NOTIFICATION_PAGINATION_LOADING"] = "setNotificationPaginationLoadingMutation";
})(Mutations || (Mutations = {}));
